import { useEffect } from "react";

const TRACKING_ID = "UA-240902707-1";

export default function AnalyticsLoader() {
  useEffect(() => {
    import("react-ga4").then((ReactGA) => {
      ReactGA.default.initialize(TRACKING_ID);
    });
  }, []);

  return null;
}
